import { Flex } from "@chakra-ui/react";
import AdminNavbarLinks from "./NavbarLinksAdmin";
import { Menu, MenuButton, MenuList, MenuItem, IconButton } from "@chakra-ui/react";
import { FaGlobe } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { FormLabel, Button } from "@chakra-ui/react";
import Select from "react-dropdown-select";
import InputText from "./../Input/Input";
import { useState, useEffect, useCallback } from "react";
import apiService from "./../../Method/Report/Report_Service";
import { useDataContext } from "./../../DataProvider";
function AdminNavbar({ routes, onLinkClick, activePath, onOpen }) {

  const { t } = useTranslation();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [Branch, setBranch] = useState([]);
  const [BranchValue, setBranchValue] = useState([]);
  const { refreshData } = useDataContext();


  const fetchData = useCallback(async () => {

    try {
      const { success, data } = await apiService.getBranch();
      if (success) {
        setBranch(data);


        if (data.length === 1) {
          const defaultBranch = [data[0].BRANCH];
          setBranchValue(defaultBranch);
          localStorage.setItem("BRANCH", JSON.stringify(defaultBranch));
        }
      }
    } catch (err) {
      console.log(err.message);
    }
    const updateFontByLanguage = () => {
      document.body.classList.remove("ku-lang", "default-lang");
      const lang = localStorage.getItem("Language");
      if (lang === "ku") {
        document.body.classList.add("ku-lang");
      } else {
        document.body.classList.add("default-lang");
      }
    };
    let fromdate = localStorage.getItem("FROM_DATE");
    if (!fromdate) {
      fromdate = formatDate(Date());
      localStorage.setItem("FROM_DATE", fromdate);
    }

    setFromDate(formatDate(fromdate));

    let todate = localStorage.getItem("TO_DATE");
    if (!todate) {
      todate = formatDate(Date());
      localStorage.setItem("TO_DATE", todate);
    }

    setToDate(formatDate(todate));

    let branch = JSON.parse(localStorage.getItem("BRANCH")) || [];
    setBranchValue(branch);
    updateFontByLanguage();


  }, []);


  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const formatApiDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };
  const handleSelectChange = (selectedOptions) => {
    const branchValues = selectedOptions.map(option => option.BRANCH);
    setBranchValue(branchValues);
  };
  const handleInsert = async (e) => {
    e.preventDefault();

    localStorage.setItem("FROM_DATE", formatApiDate(fromDate));
    localStorage.setItem("TO_DATE", formatApiDate(toDate));
    localStorage.setItem("BRANCH", JSON.stringify(BranchValue));
    refreshData()
  };

  return (
    <div className="home-navbar">
      <div className="home-navbar-container">
        <div className="navbar-content">
          <Flex justifyContent="space-between" alignItems="start" w="100%"  >
            <form onSubmit={handleInsert}>

              <Flex
                direction={{ base: "column", md: "row" }}
                flexWrap="wrap"
                align={{ base: "flex-end", md: "center" }}
                justify={{ base: "flex-start" }}
                gap={2}
              >
                <Flex align="center" gap={2} >
                  <FormLabel fontSize="17dpx" fontWeight="600" minW="30px">
                    {t("From_Date")}
                  </FormLabel>
                  <InputText
                    type="date"
                    required
                    inputStyle={{ maxWidth: "180px" }}
                    style={{ fontWeight: "500", height: "40px", fontSize: "1rem", minWidth: "180px" }}
                    value={fromDate}
                    onChange={(value) => setFromDate(value)}
                  />
                </Flex>

                <Flex align="center" gap={2} >
                  <FormLabel fontSize="17dpx" fontWeight="600" minW="30px">
                    {t("To_Date")}
                  </FormLabel>
                  <InputText
                    type="date"
                    required
                    inputStyle={{ maxWidth: "180px" }}
                    style={{ fontWeight: "500", height: "40px", fontSize: "1rem", minWidth: "180px" }}
                    value={toDate}
                    onChange={(value) => setToDate(value)}
                  />
                </Flex>

                {Branch.length > 1 && (
                  <Flex align="center" gap={2}>
                    <FormLabel fontSize="17dpx" fontWeight="600" minW="40px">
                      {t("SELECT_BRANCH")}
                    </FormLabel>
                    <Select
                      labelField="BRANCH_NAME"
                      valueField="BRANCH"
                      multi
                      style={{ fontWeight: "500", height: "40px", fontSize: "1rem", minWidth: "180px" }}

                      placeholder={t("SELECT_BRANCH")}
                      options={Branch}
                      onChange={handleSelectChange}
                    />
                  </Flex>
                )}

                <Button type="submit" className="NAVBAR-BUTTON" w={{ base: "70% !important", md: "200px !important" }}>
                  {t("Search")}
                </Button>
              </Flex>


            </form>
            <Flex
              direction="column"
              align="center"
              gap="8px"

            >
              <AdminNavbarLinks
                onOpen={onOpen}
                onLinkClick={onLinkClick}
                routes={routes}
                activePath={activePath}
              />

              <Menu>
                <MenuButton
                  as={IconButton}
                  icon={<FaGlobe />}
                  fontSize="25px"
                  mt="5px"
                  variant="unstyled"
                  color="var(--Dropdown-bg-color)"
                  aria-label="Languages"
                  _focus={{ boxShadow: "none" }}
                  _active={{ boxShadow: "none", bg: "transparent" }}
                />
                <MenuList>
                  <MenuItem
                    onClick={() => {
                      localStorage.setItem("Language", "ar");

                      window.location.reload();
                    }}
                  >
                    {t("ARABIC")}
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      localStorage.setItem("Language", "en");

                      window.location.reload();
                    }}
                  >
                    {t("ENGLISH")}
                  </MenuItem>
                  <MenuItem
                    onClick={() => {



                      localStorage.setItem("Language", "ku");

                      window.location.reload();
                    }}
                  >
                    {t("Kurdish")}
                  </MenuItem>
                </MenuList>
              </Menu>
            </Flex>


          </Flex>

        </div>

      </div>

    </div>

  );
}

export default AdminNavbar;
